import { s } from "../../../lib/styler";
import Icon from "../../commons/Icon";

export type MessagingConversationsScrollToTopButtonProps = {
    scrollTop: number;
    onClick?: () => void;
}

export default function MessagingConversationsScrollToTopButton({ onClick, scrollTop }: MessagingConversationsScrollToTopButtonProps) {
    return (
        <div className={s(`absolute bottom-[15px] right-[15px] transition-all duration-300`, {}, [
            ["visible opacity-100", "invisible opacity-0", scrollTop > 300]
        ])}>
            <div className="w-[50px] h-[50px] bg-gray-600/35 hover:bg-gray-600/60 rounded-full flex justify-center items-center text-white transition-colors duration-200 cursor-pointer" onClick={onClick}>
                <Icon name="bx-up-arrow-alt" size="30px" />
            </div>
        </div>
    );
}